import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function BlogHeader() {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const nav = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 100,
    background: 'rgba(13,17,23,0.92)',
    backdropFilter: 'blur(12px)',
    borderBottom: '1px solid rgba(255,255,255,0.06)',
  };

  const navInner = {
    maxWidth: 1140,
    margin: '0 auto',
    padding: isMobile ? '0 12px' : '0 16px',
    height: isMobile ? 52 : 56,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: isMobile ? 8 : 12,
  };

  const logo = {
    fontFamily: 'Syne, sans-serif',
    fontWeight: 800,
    fontSize: 18,
    color: '#F1F5F9',
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    cursor: 'pointer',
    lineHeight: 1,
    flexShrink: 0,
    minWidth: 0,
  };

  const ghostBtn = {
    padding: isMobile ? '6px 10px' : '6px 12px',
    background: 'transparent',
    color: '#CBD5E1',
    border: '1px solid rgba(255,255,255,0.15)',
    borderRadius: 8,
    fontSize: 12,
    fontWeight: 600,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    minHeight: isMobile ? 34 : 36,
  };

  const orangeBtn = {
    padding: '6px 14px',
    background: '#F97316',
    color: 'white',
    border: 'none',
    borderRadius: 8,
    fontSize: 12,
    fontWeight: 700,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    minHeight: isMobile ? 34 : 36,
  };

  return (
    <nav style={nav}>
      <div style={navInner}>
        <div style={logo} onClick={() => navigate('/')}>
          <span>Multi</span><span style={{ color: '#F97316' }}>Author</span>
        </div>
        <div style={{ display: 'flex', gap: isMobile ? 6 : 8, alignItems: 'center', flexShrink: 0 }}>
          <button
            style={{ ...ghostBtn, borderColor: 'rgba(249,115,22,0.4)', color: '#F97316' }}
            onClick={() => navigate('/blogs')}
          >
            Blog
          </button>
          <button style={ghostBtn} onClick={() => navigate('/login')}>
            Sign In
          </button>
          <button style={orangeBtn} onClick={() => navigate('/register')}>
            Get Started
          </button>
        </div>
      </div>
    </nav>
  );
}
